import { lazy, type ReactNode } from 'react'
import type { RouteObject } from 'react-router'

import { RequirePermission } from './guards'

const ResellersPage = lazy(() => import('@/features/platform/resellers-page'))
const ResellerDetailPage = lazy(() => import('@/features/platform/reseller-detail-page'))
const OrganizationsPage = lazy(() => import('@/features/platform/organizations-page'))
const BillingOverviewPage = lazy(() => import('@/features/platform/billing-overview-page'))

/** The cross-tenant plane (FRONTEND_PLAN F17). Revealed in the nav only to callers with no organisation. */
export function platformRoutes(lazyElement: (node: ReactNode) => ReactNode): RouteObject[] {
  return [
    {
      path: '/platform/resellers',
      element: lazyElement(
        <RequirePermission requires={['resellers:read']}>
          <ResellersPage />
        </RequirePermission>,
      ),
    },
    {
      path: '/platform/resellers/:id',
      element: lazyElement(
        <RequirePermission requires={['resellers:read']}>
          <ResellerDetailPage />
        </RequirePermission>,
      ),
    },
    {
      path: '/platform/organizations',
      element: lazyElement(
        <RequirePermission requires={['organizations:read']}>
          <OrganizationsPage />
        </RequirePermission>,
      ),
    },
    {
      path: '/platform/billing',
      element: lazyElement(
        <RequirePermission requires={['billing:overview']}>
          <BillingOverviewPage />
        </RequirePermission>,
      ),
    },
  ]
}
